import React, { FunctionComponent } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import { Document, DocumentsApi, DocumentsListOrderingEnum } from 'api';
import DashboardDocumentsTable from 'src/apps/investor/shared/dashboard-documents-table';

export interface InvestmentDocumentsTableProps {
  investmentId: string;
}

const InvestmentDocumentsTable: FunctionComponent<InvestmentDocumentsTableProps> = WithDataRecord<
  DocumentsApi,
  Document
>(DocumentsApi)(
  ({ data, ordering, onOrderBy, loading, paginationProps, investmentId }) => {
    return (
      <>
        <DashboardDocumentsTable
          onOrderBy={onOrderBy}
          ordering={ordering}
          documents={data}
          loading={loading}
          investmentId={investmentId}
          paginationProps={paginationProps}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.documentsList({
      offset,
      limit,
      ordering: ordering as DocumentsListOrderingEnum,
      ...props,
      investmentId: [props.investmentId],
    });
  },
);

export default InvestmentDocumentsTable;
